import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Resize } from 'vuetify/lib/directives'

Vue.use(Vuetify)
Vue.directive('resize', Resize)

export default new Vuetify({
	icons: {
		iconfont: 'mdi'
	},
	theme: {
		dark: false,
		options: { customProperties: true },
		themes:{
			light:{
				primary: '#663399',
				secondary: '#33CCFF',
				error: '#ff3333',
				success: '#33cc66',
				primary_blue: '#060647',
				primaryLight: '#DEDCFF',
				primaryLighter: '#E7DBF9',
				primaryDark: '#351457',
				neutral: '#f9f9f9',
				neutralDark: '#f2f2f2',
				background: '#ededed',
				primary_gray: '#aaaaaa',
			}
		}
	}
})
